import x from "./index425.js";
import { resolveComponent as a, createElementBlock as o, createCommentVNode as l, openBlock as t, createElementVNode as e, createVNode as n, withCtx as m, createTextVNode as c, Fragment as f, renderList as _, toDisplayString as p } from "vue";
/* empty css         */
import y from "./index231.js";
const L = ["data-component"], A = {
  key: 0,
  class: "relative border border-color-neutral-grey-10 border-spacing-1 footer-grid"
}, M = { class: "flex flex-col px-16 overflow-hidden first-line:native footer-grid__item screen-m:pl-24" }, S = { class: "pt-40 pb-40 footer-grid" }, F = { class: "flex flex-col px-16 overflow-hidden screen-m:px-24 screen-m:flex-row screen-m:flex-wrap footer-grid__item" }, I = { class: "mb-30 screen-m:min-w-full screen-m:max-w-full screen-l:min-w-1/4 screen-l:max-w-1/4" }, B = {
  key: 0,
  class: "mb-30 screen-m:min-w-full screen-m:max-w-full screen-l:min-w-1/4 screen-l:max-w-1/4"
}, $ = { class: "flex flex-col screen-m:flex-row screen-l:flex-col" }, N = { class: "screen-m:min-w-1/2 screen-m:max-w-1/2 screen-l:min-w-full screen-l:max-w-full screen-l:mb-30" }, V = {
  key: 0,
  class: "font-bold mb-15"
}, z = {
  key: 1,
  class: "screen-m:mb-0 mb-30"
}, C = { class: "screen-m:min-w-1/2 screen-m:max-w-1/2 screen-l:min-w-full screen-l:max-w-full" }, D = {
  key: 0,
  class: "font-bold mb-15"
}, E = {
  key: 1,
  class: "flex items-center"
}, K = { class: "mb-30 last:mb-0 screen-m:min-w-1/2 screen-m:max-w-1/2 screen-l:min-w-1/4 screen-l:max-w-1/4" }, T = { class: "mb-30 last:mb-0 screen-m:min-w-1/2 screen-m:max-w-1/2 screen-l:min-w-1/4 screen-l:max-w-1/4" }, j = {
  key: 0,
  class: "mt-40 font-bold mb-15"
}, q = {
  key: 1,
  class: "flex items-center",
  "data-test-id": "awards"
}, H = { class: "footer-grid -socket bg-color-brand-beige-50" }, W = { class: "flex px-16 overflow-hidden screen-m:px-24 footer-grid__item" }, Y = { class: "flex flex-wrap" }, Z = { class: "pt-16 pb-16" };
function G(s, r, J, O, P, Q) {
  const h = a("ms-breadcrumb"), w = a("MsLogo"), i = a("ms-footer-link"), b = a("ms-facebook"), g = a("ms-youtube"), k = a("ms-instagram"), v = a("ms-footer-privacy-link");
  return s.showFooter() ? (t(), o("footer", {
    key: 0,
    "data-component": s.$options.name
  }, [
    s.hasBreadcrumb() ? (t(), o("div", A, [
      e("div", M, [
        n(h, {
          breadcrumb: s.getFooter().breadcrumb
        }, null, 8, ["breadcrumb"])
      ])
    ])) : l("", !0),
    e("div", S, [
      e("div", F, [
        e("div", I, [
          n(w, { class: "w-[195px]" })
        ]),
        s.showAppLinks() || s.showSocialLinks() ? (t(), o("div", B, [
          e("div", $, [
            e("div", N, [
              s.showAppLinks() ? (t(), o("div", V, " Apps ")) : l("", !0),
              s.showAppLinks() ? (t(), o("ul", z, [
                e("li", null, [
                  n(i, { href: "https://home.meinestadt.de/deutschland/meinestadt-app" }, {
                    default: m(() => r[0] || (r[0] = [
                      c("Zu unseren Apps")
                    ])),
                    _: 1
                  })
                ])
              ])) : l("", !0)
            ]),
            e("div", C, [
              s.showSocialLinks() ? (t(), o("div", D, " Social Media ")) : l("", !0),
              s.showSocialLinks() ? (t(), o("ul", E, [
                e("li", null, [
                  n(i, {
                    href: "https://de-de.facebook.com/meinestadt.de/",
                    ariaLabel: "Facebook"
                  }, {
                    default: m(() => [
                      n(b, { class: "w-32 h-32" })
                    ]),
                    _: 1
                  })
                ]),
                e("li", null, [
                  n(i, {
                    href: "https://www.youtube.com/user/meinestadtde",
                    ariaLabel: "Youtube"
                  }, {
                    default: m(() => [
                      n(g, { class: "w-32 h-32" })
                    ]),
                    _: 1
                  })
                ]),
                e("li", null, [
                  n(i, {
                    href: "https://www.instagram.com/meinestadt.de/",
                    ariaLabel: "Instagram"
                  }, {
                    default: m(() => [
                      n(k, { class: "w-32 h-32" })
                    ]),
                    _: 1
                  })
                ])
              ])) : l("", !0)
            ])
          ])
        ])) : l("", !0),
        e("div", K, [
          r[1] || (r[1] = e("div", { class: "font-bold mb-15" }, "Über uns", -1)),
          e("ul", null, [
            (t(!0), o(f, null, _(s.getAboutLinks(), (d, u) => (t(), o("li", {
              key: u,
              "data-test-id": "aboutLinks"
            }, [
              n(i, {
                href: d.href
              }, {
                default: m(() => [
                  c(p(d.txt), 1)
                ]),
                _: 2
              }, 1032, ["href"])
            ]))), 128))
          ])
        ]),
        e("div", T, [
          r[4] || (r[4] = e("div", { class: "font-bold mb-15" }, "Kundenservice", -1)),
          e("ul", null, [
            e("li", null, [
              n(i, {
                href: s.getFooter().faqLink
              }, {
                default: m(() => r[2] || (r[2] = [
                  c("Hilfe & Kontakt")
                ])),
                _: 1
              }, 8, ["href"])
            ])
          ]),
          s.showAwards() ? (t(), o("div", j, " Wir sind ausgezeichnet ")) : l("", !0),
          s.showAwards() ? (t(), o("div", q, r[3] || (r[3] = [
            e("img", {
              width: "70px",
              height: "118px",
              src: "https://img.meinestadt.de/portal/common/Siegel_DT_Deutschlands_Beste_2024_meinestadt.de.jpg",
              alt: "Bild einer Auszeichnung",
              loading: "lazy"
            }, null, -1)
          ]))) : l("", !0)
        ])
      ])
    ]),
    e("div", H, [
      e("div", W, [
        e("ul", Y, [
          (t(!0), o(f, null, _(s.getSocketLinks(), (d, u) => (t(), o("li", {
            key: u,
            class: "pt-16 pb-16 mr-20"
          }, [
            n(i, {
              isInline: !0,
              href: d.href
            }, {
              default: m(() => [
                c(p(d.txt), 1)
              ]),
              _: 2
            }, 1032, ["href"])
          ]))), 128)),
          e("li", Z, [
            n(v, { privacyManagerId: s.privacyManagerId }, null, 8, ["privacyManagerId"])
          ])
        ])
      ])
    ])
  ], 8, L)) : l("", !0);
}
const se = /* @__PURE__ */ y(x, [["render", G], ["__scopeId", "data-v-97186ed2"]]);
export {
  se as default
};
